import logo from './logo.svg';
import './App.css';
import {useContext, useEffect, useRef, useState} from "react";
import Main from "./views/Main";
import {ConfigProvider, theme, App as AntdApp} from "antd";
import AppContextProvider, {appContext} from "./state";
import AuthProvider from "./hooks/AuthProvider";
import {Route, Routes} from 'react-router-dom'
import RouteSignIn from "./routes/RouteSignIn";
import RouteLogout from "./routes/RouteLogout";
import RouteSignUp from "./routes/RouteSignUp";
import RouteForgotPassword from "./routes/RouteForgotPassword.js";
import RouteResetPassword from "./routes/RouteResetPassword.js";
import RouteSettings from "./routes/RouteSettings.js";
import RouteProfile from "./routes/RouteProfile.js";
import RoutePlayground from "./routes/RoutePlayground.js";
import { GoogleOAuthProvider } from '@react-oauth/google';
import Clone from "./utils/clone";
import AppWrapper from "./AppWrapper";
import AppLocalStorage from "./storage/localStorage";
import MainMenuBar from "./components/MainMenuBar";
import Home from "./views/Home";

function App() {

    function onSignInSuccess () {
        console.log('onSignInSuccess')
    }

    function onSignUpSuccess () {
        console.log('onSignUpSuccess')
    }

    function onLogout (){

    }

  return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_AUTH_GOOGLE_ID}>
      <AppContextProvider>
          <ConfigProvider
              theme={{
                  algorithm: theme.darkAlgorithm,
                  token: {
                      colorPrimary: '#1890ff',
                      borderRadius: 2,
                      colorTextBase: '#FFFFFF',
                      colorBgContainer: '#282A35',
                  },
              }}
          >
              <AntdApp>
              <AppWrapper>
                  <div data-node-env={process.env.NODE_ENV} data-env={process.env.REACT_APP_ENV} className="App">
                      <Main>
                              <Routes>
                                  <Route path="/" element={<Home></Home>}/>
                                  <Route path="/signin" element=<RouteSignIn
                                         onSignInSuccess={onSignInSuccess.bind(this)}/>/>
                                  <Route path="/logout" element=<RouteLogout onLogOut={onLogout.bind(this)}/>/>
                                  <Route path="/signup" element=<RouteSignUp
                                         onSignUpSuccess={onSignUpSuccess.bind(this)}/>/>
                                  <Route path="/forgot-password" element=<RouteForgotPassword/>/>
                                  <Route path="/reset-password" element=<RouteResetPassword/>/>
                                  <Route path="/settings" element=<RouteSettings/>/>
                                  {process.env.REACT_APP_ENV !== 'PRODUCTION' ? <>
                                      <Route path="/profile" element=<RouteProfile/>/>
                                      <Route path="/playground" element=<RoutePlayground/>/>
                                  </> : false}
                              </Routes>
                      </Main>
                      </div>
              </AppWrapper>
              </AntdApp>

          </ConfigProvider>
      </AppContextProvider>
      </GoogleOAuthProvider>

  );
}

export default App;
